var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Search"},[_c('van-search',{attrs:{"show-action":"","placeholder":"请输入搜索关键词"},on:{"search":_vm.onSearch,"cancel":_vm.onCancel},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }